require('./ActionLog')
require('./AdverseTerms')
require('./AuditTrail')
require('./BulkUpload')
require('./BulkUploadMappings')
require('./CommentModal')
require('./Entity')
require('./Exports')
require('./Login')
require('./ManageUsers')
require('./Monitoring')
require('./Plugins')
require('./Preferences')
require('./PreferencesWorkflowEdit')
require('./PreferencesWorkflowList')
require('./Project')
require('./Project')
require('./ProjectExport')
require('./ProjectManual')
require('./ProjectNew')
require('./Reports')
require('./Reports')
require('./ResearchRequestModal')
require('./Root')
require('./Sources')
require('./StarredDocumentUpload')
require('./StarredDocumentCreate')
require('./StarredDocumentLink')
require('./SupportList')
require('./UserPreferences')
